import React, { useRef } from "react";
import { Image } from "react-bootstrap";
// internal
// import thumb_shape_1 from "assets/img/about/15/about-thumb-shape.png";
import thumb_shape_2 from "assets/img/about/15/about-thumb-shape-2.png";
const ServiceThreeAbout = ({
  t1 = "",
  subtitle = "",
  p = "",
  reverse = false,
  ambient = false,
  list = [],
  about_img = "" }) => {
  const ambientRef = useRef(null);
  const handleAmbientMove = (event) => {
    if (!ambientRef.current) return;

    ambientRef.current.querySelectorAll("[data-repel]").forEach((element) => {
      const rect = element.getBoundingClientRect();
      const elementX = rect.left + rect.width / 2;
      const elementY = rect.top + rect.height / 2;
      const distanceX = elementX - event.clientX;
      const distanceY = elementY - event.clientY;
      const distance = Math.hypot(distanceX, distanceY);
      const radius = 210;

      if (distance < radius) {
        const strength = (radius - distance) / radius;
        const pushX = (distanceX / Math.max(distance, 1)) * strength * 42;
        const pushY = (distanceY / Math.max(distance, 1)) * strength * 42;

        element.style.setProperty("--repel-x", `${pushX}px`);
        element.style.setProperty("--repel-y", `${pushY}px`);
        element.classList.add("is-repelling");
      } else {
        element.style.setProperty("--repel-x", "0px");
        element.style.setProperty("--repel-y", "0px");
        element.classList.remove("is-repelling");
      }
    });
  };
  const handleAmbientLeave = () => {
    if (!ambientRef.current) return;

    ambientRef.current.querySelectorAll("[data-repel]").forEach((element) => {
      element.style.setProperty("--repel-x", "0px");
      element.style.setProperty("--repel-y", "0px");
      element.classList.remove("is-repelling");
    });
  };

  return (
    <>
      <section
        className={`about__area pt-130 ${ambient ? "game-service-ambient" : ""}`}
        onMouseMove={ambient ? handleAmbientMove : undefined}
        onMouseLeave={ambient ? handleAmbientLeave : undefined}
      >
        {ambient && (
          <div className="game-service-ambient__layer" aria-hidden="true" ref={ambientRef}>
            <span className="game-service-ambient__ring game-service-ambient__ring--one" data-repel></span>
            <span className="game-service-ambient__ring game-service-ambient__ring--two" data-repel></span>
            <span className="game-service-ambient__chip game-service-ambient__chip--one" data-repel>Unity</span>
            <span className="game-service-ambient__chip game-service-ambient__chip--two" data-repel>Unreal</span>
            <span className="game-service-ambient__chip game-service-ambient__chip--three" data-repel>VR</span>
            <span className="game-service-ambient__spark game-service-ambient__spark--one" data-repel></span>
            <span className="game-service-ambient__spark game-service-ambient__spark--two" data-repel></span>
          </div>
        )}
        <div className="container">
          <div className="row">
            {reverse === false ? (
              <>
                <div className="col-xl-6 col-lg-6">
                  <div
                    className="about__thumb-15 p-relative z-index-1 w-img wow fadeInUp"
                    data-wow-delay=".3s"
                    data-wow-duration="1s"
                  >
                    <div className="mt-2 about__thumb-15-shape">
                      {/* <Image src={thumb_shape_1} alt="shape" /> */}
                    </div>
                    <Image
                      className="about__thumb-15-shape-2"
                      src={thumb_shape_2}
                      alt="shape"
                    />
                    <Image src={about_img} alt="about img" />
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div
                    className="about__wrapper-15 pl-45 wow fadeInUp"
                    data-wow-delay=".6s"
                    data-wow-duration="1s"
                  >
                    <div className="tp-section-wrapper-3 mb-25">
                      <span className="tp-section-subtitle-3">{subtitle}</span>
                      <h3 className="tp-section-title-3">{t1}</h3>
                      <p>{p}</p>
                    </div>
                    <div className="about__list-2">
                      <ul>
                        {list.map((val) => {
                          return (
                            <>
                              <li>{val}</li>{" "}
                            </>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="col-xl-6 col-lg-6">
                  <div
                    className="about__wrapper-15 pl-45 wow fadeInUp"
                    data-wow-delay=".6s"
                    data-wow-duration="1s"
                  >
                    <div className="tp-section-wrapper-3 mb-25">
                      <span className="tp-section-subtitle-3">{subtitle}</span>
                      <h3 className="tp-section-title-3">{t1}</h3>
                      <p>{p}</p>
                    </div>
                    <div className="about__list-2">
                      <ul>
                        {list.map((val) => {
                          return (
                            <>
                              <li>{val}</li>{" "}
                            </>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div
                    className="about__thumb-15 p-relative z-index-1 w-img wow fadeInUp"
                    data-wow-delay=".3s"
                    data-wow-duration="1s"
                  >
                    <div className="mt-4 about__thumb-15-shape">
                      {/* <Image src={thumb_shape_1} alt="shape" /> */}
                    </div>
                    <Image
                      className="about__thumb-15-shape-2"
                      src={thumb_shape_2}
                      alt="shape"
                    />
                    <Image src={about_img} alt="about img" />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default ServiceThreeAbout;
